// Import dependencies
import React from 'react';
import axios from 'axios';
import cookie from 'js-cookie';
import { tokenize } from '../../../../helper';
import { FaTrashAlt, FaKey, FaPaperPlane } from 'react-icons/fa';
import { displayEmailVerified, displayAffiliateNumber, navigateToMemberDetail } from '../uiAdminHelpers';

// Import stlying
import './MemberAdministrationPage.css';
import AdminNavbar from '../../../reusables/adminNavbar';

// Import config
import config from '../../../../configs/config.json';
const API_URL = config.API_URL;
const ADMIN_API_URL = API_URL + '/admin';
const AUTH_URL = config.AUTH_URL;

class LoginHistoryPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            members: [],
            selectedIndex: 0,
            stats: {
                daily: 0,
                monthly: 0,
                yearly: 0,
                total: 0,
            },
            sortKey: 'NAMEASC'
        }
    }

    componentDidMount() {
        // As the component mounts, check if a token is already stored in the cookie
        var token = cookie.get('token');
        var user_type = cookie.get('user-type');
        if (token) {
            if (user_type === 'admin') {
                // Authorized as admin
                this.fetchMembers();
            } else {
                // Not authorized as admin, re-direct to log in page
                window.location.href = '/admin/';
            }
        } else {
            // No token found, re-direct to log in page
            window.location.href = '/admin/'
        }

    }

    fetchMembers = () => {
        // Make API request to back-end to fetch the current list of members;
        axios.get(`${ADMIN_API_URL}/members?sort=${this.state.sortKey}`, tokenize())
            .then(response => {
                console.log(response.data);
                this.setState({ members: response.data.members, stats: response.data.stats });
            })
            .catch(error => {
                console.log('Failed to retrieve members');
                console.log(error);
            })
    }

    handleSortRequest = (type) => {
        switch (type) {
            case 'name':
                (this.state.sortKey === 'NAMEASC') ? this.setState({ sortKey: 'NAMEDESC' }) : this.setState({ sortKey: 'NAMEASC' });
                break;
            case 'email':
                (this.state.sortKey === 'EMAILASC') ? this.setState({ sortKey: 'EMAILDESC' }) : this.setState({ sortKey: 'EMAILASC' });
                break;
            case 'emailVerified':
                (this.state.sortKey === 'EMAILVERIFIEDASC') ? this.setState({ sortKey: 'EMAILVERIFIEDDESC' }) : this.setState({ sortKey: 'EMAILVERIFIEDASC' });
                break;
            case 'id':
                (this.state.sortKey === 'IDASC') ? this.setState({ sortKey: 'IDDESC' }) : this.setState({ sortKey: 'IDASC' });
                break;
            case 'affiliate':
                (this.state.sortKey === 'AFFILIATEASC') ? this.setState({ sortKey: 'AFFILIATEDESC' }) : this.setState({ sortKey: 'AFFILIATEASC' });
                break;
            case 'registeredDate':
                (this.state.sortKey === 'REGISTEREDASC') ? this.setState({ sortKey: 'REGISTEREDDESC' }) : this.setState({ sortKey: 'REGISTEREDASC' });
                break;
            default:
                this.setState({ sortKey: 'NAMEASC' });
        }

        setTimeout(() => {
            this.fetchMembers();
        }, 100)

    }

    handleActionButtonClick = (index) => {
        // Select a member   
        this.setState({ selectedIndex: index });
    }

    confirmResendEmailVerification = () => {
        let memberID = this.state.members[this.state.selectedIndex].ID; // SQL database member record ID

        axios.post(`${AUTH_URL}/verify/resend/${memberID}`)
            .then(result => {
                console.log(result.data);
                if (result.data.success) {
                    console.log('Successfully sent password reset email');
                }

            })
            .catch(error => {
                console.log(error);
            })
    }

    confirmDelete = () => {
        // User has confirmed they want to delete a member, make the backend call to handle delete
        let dbMemberID = this.state.members[this.state.selectedIndex].ID; // SQL database member record ID

        axios.delete(`${ADMIN_API_URL}/members/${dbMemberID}`, tokenize())
            .then(result => {

                console.log(result.data);
                if (result.data.success) {
                    this.fetchMembers();
                    this.setState({
                        selectedIndex: 0
                    })
                }

            })
            .catch(error => {
                console.log(error);
            })
    }

    confirmPasswordReset = () => {
        // User has confirmed they want to send a password reset email to member, make the backend call to handle accordingly
        let memberEmail = this.state.members[this.state.selectedIndex].email; // SQL database member record ID
        // console.log("Send to: ", memberEmail);

        axios.post(`${AUTH_URL}/forgot`, { email: memberEmail })
            .then(result => {

                console.log(result.data);
                if (result.data.success) {
                    console.log('Successfully sent password reset email');
                }

            })
            .catch(error => {
                console.log(error);
            })
    }

    render() {

        return (<div>
            <AdminNavbar />

            <h1 className='pageTitle'>Registered Members</h1>
            <p style={{ textAlign: 'center' }}>*Use <strong>CTR</strong> + <strong>F</strong> to search for member by name.</p>

            <div className='loginStatsContainer'>
                <div>Daily {this.state.stats.daily}</div>
                <div>Monthly {this.state.stats.monthly}</div>
                <div>Yearly {this.state.stats.yearly}</div>
                <div>Total {this.state.stats.total}</div>
            </div>

            <table className='table-striped generalTable loginHistoryTable'>
                <thead>
                    <tr>
                        <td onClick={() => this.handleSortRequest('name')}>Member Name</td>
                        <td onClick={() => this.handleSortRequest('email')}>Member Email</td>
                        <td onClick={() => this.handleSortRequest('emailVerified')}>Email Verified</td>
                        <td onClick={() => this.handleSortRequest('id')}>OLLI Member ID</td>
                        <td onClick={() => this.handleSortRequest('affiliate')}>Affiliate</td>
                        <td onClick={() => this.handleSortRequest('registeredDate')}>Registered Date</td>
                        <td></td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    {

                        this.state.members.map((member, index) => {
                            // let date = member.member_since.slice(0,10);
                            // let time = member.member_since.slice(11,16)

                            console.log(member)


                            return (<tr key={index}>
                                <td onClick={() => navigateToMemberDetail(member.ID)}>{member.name}</td>
                                <td onClick={() => navigateToMemberDetail(member.ID)}>{member.email}</td>
                                <td onClick={() => navigateToMemberDetail(member.ID)}>{displayEmailVerified(member.email_verified)}</td>
                                <td onClick={() => navigateToMemberDetail(member.ID)}>{member.olli_member_id}</td>
                                <td onClick={() => navigateToMemberDetail(member.ID)}>{displayAffiliateNumber(member.affiliate_code)}</td>
                                <td onClick={() => navigateToMemberDetail(member.ID)}>{member.member_since}</td>
                                <td>
                                    {(member.email_verified) ?
                                        <button type='button' className='btn btn-secondary' title='Reset Password' data-toggle='modal' data-target='#resetPasswordModal' onClick={() => this.handleActionButtonClick(index)}><FaKey /></button>
                                        :
                                        <button type='button' className='btn btn-warning' title='Resend Email Verification' data-toggle='modal' data-target='#resendEmailVerificationModal' onClick={() => this.handleActionButtonClick(index)}><FaPaperPlane /></button>
                                    }
                                </td>
                                <td><button type='button' className='btn btn-danger' title='Delete Member' data-toggle='modal' data-target='#deleteMemberModal' onClick={() => this.handleActionButtonClick(index)}><FaTrashAlt /></button></td>
                            </tr>)

                        }) // End map function
                    }
                </tbody>
            </table>


            {/* Resend Email Verification Modal */}
            <div className="modal fade" id="resendEmailVerificationModal" tabIndex="-1" role="dialog" aria-labelledby="resendEmailVerificationModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="resendEmailVerificationModalLabel">Resend Email Verification</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Resend email verification for {this.state.members.length !== 0 ? this.state.members[this.state.selectedIndex].email : ''}?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.confirmResendEmailVerification}>Resend</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Reset Password Modal */}
            <div className="modal fade" id="resetPasswordModal" tabIndex="-1" role="dialog" aria-labelledby="resetPasswordModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="resetPasswordModalLabel">Reset Password</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Send password reset for {this.state.members.length !== 0 ? this.state.members[this.state.selectedIndex].email : ''}?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.confirmPasswordReset}>Send</button>
                        </div>
                    </div>
                </div>
            </div>


            {/* Delete Member Modal */}
            <div className="modal fade" id="deleteMemberModal" tabIndex="-1" role="dialog" aria-labelledby="deleteMemberModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteMemberModalLabel">Delete Member</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Are you sure you want to delete {this.state.members.length !== 0 ? this.state.members[this.state.selectedIndex].name : ''}?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={this.confirmDelete}>Delete</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }
}

export default LoginHistoryPage;